import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

import { env, RAVEN_CLIENT_KEY, RAVEN_OPTIONS } from './config';

if (env.production) {
  Raven
    .config(RAVEN_CLIENT_KEY, RAVEN_OPTIONS)
    .addPlugin(RavenVue, Vue)
    .install();
}



// WEBPACK FOOTER //
// ./common/sentry.js